import React from 'react';
import { Box, Link } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';

/**
 * @typedef {object} CusLinkOwnProps
 * @property {string} text - Ключ для перевода через i18next
 * @property {string} to - Путь для навигации (react-router)
 * @property {string} state - какая то информация для навигации
 * @property {string} [linkComponent] - Компонент ссылки
 * @property {React.HTMLAttributeAnchorTarget} target - вариант ссылки
 * @property {React.CSSProperties} [style] - Inline-стили для Box
 * @typedef {CusLinkOwnProps & import('@mui/material').BoxProps} CusLinkProps
 *
 * @param {CusLinkProps} props
 */

export default function CusLink({
  text,
  to,
  style,
  target,
  href,
  linkComponent = RouterLink,
  fontSize = '14px',
  linkSx,
  children,
  state = {},
  color,
  ...boxProps
}) {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <Box
      sx={{ width: 'fit-content' }}
      style={{ ...style }}
      onClick={href ? undefined : (e) => e.preventDefault()}
      component={'span'}
      {...boxProps}>
      <Link
        target={target}
        component={linkComponent}
        color={color}
        to={to}
        href={href}
        state={{ from: location.pathname, ...state }}
        sx={{
          cursor: 'pointer',
          textDecoration: 'underline',
          '&:hover': { textDecoration: 'none' },
          fontSize: fontSize,
          ...linkSx
        }}>
        {children || (typeof text == 'string' ? t(text) : text)}
      </Link>
    </Box>
  );
}
